import { createRoot } from "react-dom/client"
import "./styles.css"
import App from "./App"
import AppRinger from "./AppRinger"

createRoot(document.getElementById("root")).render(<App />)
